module.exports = function _arrayFromIterator(iter) {
  var list = [];
  var next;
  while (!(next = iter.next()).done) {
    list.push(next.value);
  }
  return list;
};



//////////////////
// WEBPACK FOOTER
// ./~/coact/~/ramda/src/internal/_arrayFromIterator.js
// module id = 1457
// module chunks = 0